import {FaLinkedin, FaGithub} from "react-icons/fa"
import {HiOutlineMail} from "react-icons/hi"
import {BsFillPersonLinesFill, BsTwitterX} from "react-icons/bs"
const SocialLinks = () => {
  const links =[
    {
      id:1,
      child:(
        <>
          LinkedIn <FaLinkedin size={30}/>
        </>
      ),
      href:"https://www.linkedin.com/in/kisang-alex-07bb04250/",
      style:"rounded-tr-md"
    },
   
    {
      id:2,
      child:(
        <>
          Github <FaGithub size={30}/>
        </>
      ),
      href:"https://github.com/Ali-Kisang",
    },
    {
      id:3,
      child:(
        <>
          Mail <HiOutlineMail size={30}/>
        </>
      ),
      href:"mailto:kipkosgeialex3@gmail.com",
    },
    {
      id:4,
      child:(
        <>
          Twitter || X <BsTwitterX 
           size={30}/>
        </>
      ),
      href:"https://twitter.com/AliKisang",
    },
    {
      id:5,
      child:(
        <>
            Resume <BsFillPersonLinesFill size={30}/>
        </>
      ),
      href:"/Kisang_Alex_Resume.pdf",
      style:"rounded-br-md",
      download:true
    },
  ]
  return (
    <div className="flex flex-col top-[35%] left-0 fixed">
      <ul >
      {
        links.map(({id, href, child, download, style})=>(
          <li key={id} className={"flex justify-between items-center w-40 h-14 px-4  ml-[-100px] hover:rounded-md hover:ml-[-10px] duration-500 bg-gray-500 cursor-pointer" + "" + style}>
        <>
        <a 
        href={href}
        download={download}
        target="_blank"
        rel="noreferrer"
        className="flex justify-between items-center w-full text-white"
        >
        {child}
        </a>
        </>
        </li>
        ))
        }
      </ul>
    </div>
  )
}

export default SocialLinks